export const iconFontAwesomeSpinnersLifeRing = (
	<i className="fa-solid fa-life-ring"></i>
);
